"use client";
export const sendSalesforceInteraction = (attributes: any): void => {
  if (typeof window !== "undefined") {
    if ((window as any)?.OnetrustActiveGroups?.includes("C0002")) {
      const SalesforceInteractions = (window as any).SalesforceInteractions;

      if (
        SalesforceInteractions &&
        SalesforceInteractions.sendEvent !== "undefined"
      ) {
        try {
          SalesforceInteractions.setLoggingLevel(5);
          try {
            SalesforceInteractions.init({
              consents: [
                {
                  provider: "OneTrust",
                  purpose: "Tracking",
                  status: SalesforceInteractions.ConsentStatus.OptIn,
                },
              ],
            });
          } catch (err) {
            // console.log(err);
          }
          SalesforceInteractions.sendEvent({
            interaction: attributes,
          });
          console.log(`Event "${attributes?.name}" sent successfully.`);
        } catch (error) {
          console.error("Error sending Salesforce interaction:", error);
        }
      } else {
        console.error(
          "SalesforceInteractions is not available or does not have the sendEvent method."
        );
      }
    } else {
      const SalesforceInteractions = (window as any).SalesforceInteractions;
      SalesforceInteractions.init({
        consents: [
          {
            provider: "OneTrust",
            purpose: "Tracking",
            status: SalesforceInteractions.ConsentStatus.OptOut,
          },
        ],
      });
      console.error("The window object is not defined.");
    }
  }
};
